module.exports = __webpack_public_path__ + "img/bld1.9366f2ce.png";